import React, { useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useIntl } from 'react-intl';

ChartJS.register(ArcElement, Tooltip, Legend);

const centerTextPlugin = {
	id: 'centerText',
	afterDraw(chart) {
		const { ctx, chartArea } = chart;
		if (!chartArea) return;
		const centerX = (chartArea.left + chartArea.right) / 2;
		const centerY = (chartArea.top + chartArea.bottom) / 2;
		ctx.save();
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = '#0F172A';
		ctx.font = '700 28px Inter, system-ui, -apple-system, Segoe UI, Roboto';
		ctx.fillText('40%', centerX, centerY - 6);
		ctx.fillStyle = '#64748B';
		ctx.font = '500 12px Inter, system-ui, -apple-system, Segoe UI, Roboto';
		ctx.fillText('Tin nhắn web', centerX, centerY + 14);
		ctx.restore();
	}
};

const hoverScalePlugin = {
	id: "hoverScale",
	afterEvent(chart, args) {
		const { event } = args;
		const arcs = chart.getDatasetMeta(0).data;

		arcs.forEach((arc) => {
			if (!arc.$originalRadius) {
				arc.$originalRadius = arc.outerRadius; // lưu bán kính gốc
			}
		});

		if (event.type === "mousemove") {
			const active = chart.getActiveElements();
			arcs.forEach((arc) => {
				if (active.length && arc === active[0].element) {
					arc.outerRadius = arc.$originalRadius * 1.1; // phóng to 110%
				} else {
					arc.outerRadius = arc.$originalRadius; // reset về gốc
				}
			});
		}
	},
};

const MessageChannelStats = ({ className = '' }) => {
	const { formatMessage } = useIntl();

	const labels = ['Web', 'Facebook', 'Zalo'];
	const values = [40, 35, 25];

	const data = useMemo(() => ({
		labels,
		datasets: [
			{
				label: 'Channels',
				data: values,
				backgroundColor: (ctx) => {
					const colors = [
						['#79D19A', '#2BA24F'], // green gradient
						['#FFD08A', '#FF8C2E'], // orange gradient
						['#FFA7C7', '#FF6FA1']  // pink gradient
					];
					const { chart, dataIndex } = ctx;
					const { ctx: c } = chart;
					const gradient = c.createLinearGradient(0, 0, chart.width, 0);
					gradient.addColorStop(0, colors[dataIndex][0]);
					gradient.addColorStop(1, colors[dataIndex][1]);
					return gradient;
				},
				borderWidth: 0,
				spacing: 0,
				cutout: '60%'
			}
		]
	}), []);

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: { display: false },
			tooltip: { enabled: true }
		},
		layout: {
			padding: 20, // chừa khoảng cách để miếng phóng to không đè border
		},
	};

	const bullets = [
		{ color: '#FF8C2E', label: 'Tin nhắn Facebook', value: '124', delta: '+12', deltaColor: '#FF5A5A' },
		{ color: '#FF6FA1', label: 'Tin nhắn Facebook', value: '124', delta: '+12', deltaColor: '#FF5A5A' },
		{ color: '#2BA24F', label: 'Tin nhắn Facebook', value: '124', delta: '(20%)', deltaColor: '#2BA24F' }
	];

	return (
		<div className={`border p-5 pt-6 rounded-lg shadow-lg h-full flex flex-col ${className}`}>
			<p className='text-lg font-medium pb-3'>
				{formatMessage({ id: 'DASHBOARD.TIME_STATS.TITLE' })}
			</p>
			<div className='grid grid-cols-1 md:grid-cols-2 gap-6 flex-1 min-h-0'>
				<div className='min-h-[240px] md:min-h-0 flex items-center justify-center'>
					<div className='w-full h-64 md:h-full overflow-visible'>
						<Doughnut data={data} options={options} plugins={[centerTextPlugin, hoverScalePlugin]} />
					</div>
				</div>
				<div className='flex flex-col justify-center'>
					<div>
						<p className='text-4xl font-bold text-[#173F5C] leading-tight'>20.000</p>
						<p className='text-sm text-[#7C7C7C]'>Tin nhắn</p>
					</div>
					<div className='mt-4 space-y-3'>
						{bullets.map((b, i) => (
							<div key={i} className='flex items-center gap-3'>
								<span className='w-2.5 h-2.5 rounded-full' style={{ backgroundColor: b.color }} />
								<span className='text-sm font-semibold text-[#173F5C]'>{b.value}</span>
								<span className='text-xs font-semibold' style={{ color: b.deltaColor }}>{b.delta}</span>
								<span className='text-sm text-[#7C7C7C]'>{b.label}</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export { MessageChannelStats };

